import React from 'react';
import styled from 'styled-components';
import { Colors, FontSize } from '../../../assets';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard } from '@fortawesome/free-regular-svg-icons';
import { faChartLine, faGear, faUserGear, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const ActionCardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

const Card = styled(Link)`
  background: ${Colors.white};
  border-radius: 16px;
  padding: 2rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;
  border: 2px solid transparent;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, ${Colors.primary} 0%, ${Colors.secondary} 100%);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
    border-color: ${Colors.primary};

    &::before {
      transform: scaleX(1);
    }
  }

  &:hover svg {
    transform: scale(1.1);
    color: ${Colors.orange};
  }
`;

const IconWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${Colors.lightBackground} 0%, ${Colors.lightText} 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;

  svg {
    color: ${Colors.primary};
    font-size: ${FontSize.largeIcon};
    transition: all 0.3s ease;
  }
`;

const CardTitle = styled.h3`
  color: ${Colors.mainText};
  font-size: ${FontSize.subTitle};
  font-weight: 600;
  margin: 0;
  letter-spacing: -0.3px;
`;

const CardDescription = styled.p`
  color: ${Colors.grey};
  font-size: ${FontSize.small};
  margin: 0.5rem 0 0 0;
  font-weight: 400;
`;

interface ActionItem {
  icon: any;
  title: string;
  description: string;
  path: string;
}

const actions: ActionItem[] = [
  {
    icon: faAddressCard,
    title: 'Přehled protokolů',
    description: 'Zobrazit všechny protokoly',
    path: '/protocol-list'
  },
  {
    icon: faUserPlus,
    title: 'Nový zemřelý',
    description: 'Přidat nového zemřelého',
    path: '/deceased'
  },
  {
    icon: faUserGear,
    title: 'Správa',
    description: 'Spravovat systém',
    path: '/management'
  },
  {
    icon: faChartLine,
    title: 'Statistiky',
    description: 'Zobrazit statistiky',
    path: '/statistics'
  }
  // {
  //   icon: faGear,
  //   title: 'Nastavení',
  //   description: 'Nastavení systému',
  //   path: '/settings'
  // }
];

export const ActionCards: React.FC = () => {
  return (
    <ActionCardsGrid>
      {actions.map((action, index) => (
        <Card key={index} to={action.path}>
          <IconWrapper>
            <FontAwesomeIcon icon={action.icon} />
          </IconWrapper>
          <CardTitle>{action.title}</CardTitle>
          <CardDescription>{action.description}</CardDescription>
        </Card>
      ))}
    </ActionCardsGrid>
  );
};
